/**
 * Builds the redirect URL for upgrade completion
 */
export const buildRedirectUrl = (metaSiteId?: string): string => {
  if (!metaSiteId) {
    return 'https://manage.wix.com/';
  }
  return `https://manage.wix.com/dashboard/${metaSiteId}`;
};

/**
 * GTM event configuration for upgrade completion
 */
export const getUpgradeCompleteGTMConfig = (metaSiteId?: string) => ({
  metaSiteId,
  flow: 'ai-create-store' as const,
});
